import { FieldConfig } from "layouts/NewUniversalField/NewUniversalField";

type ValidatorMode = "change" | "submit";

export function buildCustomerParamsValidator(
  fields: FieldConfig[],
  mode: ValidatorMode = "change",
) {
  return (values: Record<string, string>) => {
    const errors: Record<string, string> = {};

    for (const f of fields) {
      const v = (values[f.id] ?? "").trim();
      const vLen = v.length;
      const { required, validations } = f;

      if (required && vLen === 0) {
        errors[f.id] = "This field is required.";
        continue;
      }
      if (!vLen) continue; // optional and empty => ok

      const minL = validations?.minLength;
      const maxL = validations?.maxLength;
      const pattern = validations?.pattern;

      if (minL && vLen < minL) {
        errors[f.id] = `Minimum ${minL} characters required.`;
        continue;
      }
      if (maxL && vLen > maxL) {
        errors[f.id] = `Maximum ${maxL} characters allowed.`;
        continue;
      }

      // PATTERN RULE:
      // - submit mode: always enforce pattern
      // - change mode: enforce pattern only when "complete"
      //   -> if maxLength exists, wait until vLen === maxLength
      //   -> else if only minLength exists, wait until vLen >= minLength
      if (pattern) {
        const shouldValidatePattern =
          mode === "submit"
            ? true
            : maxL
              ? vLen === maxL
              : minL
                ? vLen >= minL
                : vLen > 0;

        if (shouldValidatePattern && !pattern.test(v)) {
          errors[f.id] = "Invalid format.";
          continue;
        }
      }
    }

    return errors;
  };
}

// export function buildCustomerParamsValidator(fields: FieldConfig[]) {
//   return (values: Record<string, string>) => {
//     const errors: Record<string, string> = {};

//     for (const f of fields) {
//       const v = (values[f.id] ?? "").trim();
//       const vLen = v?.length;
//       const { required, validations } = f;

//       if (required && vLen === 0) {
//         errors[f.id] = "This field is required.";
//         continue;
//       }
//       if (!vLen) continue; // optional and empty => ok

//       if (validations?.minLength && vLen < validations.minLength) {
//         errors[f.id] = `Minimum ${validations.minLength} characters required.`;
//         continue;
//       }
//       if (validations?.maxLength && vLen > validations.maxLength) {
//         errors[f.id] = `Maximum ${validations.maxLength} characters allowed.`;
//         continue;
//       }
//       if (validations?.pattern && !validations.pattern.test(v)) {
//         errors[f.id] = "Invalid format.";
//         continue;
//       }
//     }

//     return errors;
//   };
// }
